import ServiceCRUD from '../../../services/ServiceCRUD';
import { apiCase as http } from '../../../http';

class ServiceChannelService extends ServiceCRUD {
  constructor() {
    super('service-channel');
  }

  create(data) {
    return http.post('service-channel', data);
  }

  getWithoutPagination() {
    return http.get('service-channel/all');
  }

  getPagination({ page, search = '' }) {
    return http.get('service-channel', {
      params: {
        page,
        search
      }
    });
  }

  getByKey(key) {
    return http.get(`service-channel/:${key}`);
  }

  update(key, data) {
    return http.put(`service-channel/${key}`, data);
  }
  delete(key) {
    return http.delete(`service-channel/:${key}`);
  }
}

export default new ServiceChannelService();
